import { createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../_helpers/_methods';
import { setUiMessage } from './ui';

export const initialState = {
  loading: false,
  hasErrors: false,
  defaultCertificates: [],
  totalCount: 0,
  activeDefaultCertificate: null
};

// A slice
const defaultCertificateSlice = createSlice({
  name: 'defaultCertificate',
  initialState,
  reducers: {
    setDefaultCertificates: (state, action) => {
      state.defaultCertificates = action.payload.data;
      state.totalCount = action.payload.count;
    },
    setDefaultCertificate: (state, action) => {
      state.activeDefaultCertificate = action.payload;
    },
    setNewDefaultCertificate: (state, action) => {
      let teampDefaultCertificates = [...state.defaultCertificates];
      if (action.payload.is_default && teampDefaultCertificates.length) {
        teampDefaultCertificates = teampDefaultCertificates.map((defaultCertificate) => ({
          ...defaultCertificate,
          is_default: false
        }));
      }
      state.defaultCertificates = [action.payload, ...teampDefaultCertificates];
    },
    patchDefaultCertificate: (state, action) => {
      let tempDefaultCertificates = [...state.defaultCertificates];
      const index = tempDefaultCertificates.findIndex((dc) => dc.id === action.payload.id);
      if (index !== -1) {
        tempDefaultCertificates = tempDefaultCertificates.map((dc) => ({
          ...dc,
          is_default: false
        }));
        tempDefaultCertificates[index] = action.payload;
      }
      state.defaultCertificates = [...tempDefaultCertificates];
    },
    removeDefaultCertificate: (state, action) => {
      let tempDefaultCertificates = [...state.defaultCertificates];
      const index = tempDefaultCertificates.findIndex((dc) => dc.id === action.payload);
      tempDefaultCertificates.splice(index, 1);
      state.defaultCertificates = [...tempDefaultCertificates];
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

// Actions generated from the slice
const {
  setDefaultCertificates,
  setNewDefaultCertificate,
  patchDefaultCertificate,
  setDefaultCertificate,
  removeDefaultCertificate,
  setLoading
} = defaultCertificateSlice.actions;

// export user selector to get the slice in any component
export const defaultCertificateSelector = (state) => state.defaultCertificate;

// export The reducer
const defaultCertificateReducer = defaultCertificateSlice.reducer;

export default defaultCertificateReducer;

// Actions
export const fetchDefaultCertificate = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await fetchWrapper.get('/certificate/template/');
    dispatch(setDefaultCertificates({ data: response.data.results, count: response.data.count }));
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    ErrorMessageHandler(error);
  }
};
export const fetchActiveCertificate = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await fetchWrapper.get('/certificate/template/active/');
    dispatch(setDefaultCertificate(response.data));
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    ErrorMessageHandler(error);
  }
};

export const createDefaultCertificate =
  (formData, handleHideCertificateBuilder, lang) => async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await fetchWrapper.post(`/certificate/template/`, formData, true);
      dispatch(setNewDefaultCertificate(response.data));
      dispatch(
        setUiMessage(
          lang === 'ne'
            ? ' प्रमाणपत्र टेम्प्लेट सफलतापूर्वक सिर्जना गरियो'
            : 'Certificate template created successfully'
        )
      );

      dispatch(setLoading(false));
      handleHideCertificateBuilder();
    } catch (error) {
      dispatch(setLoading(false));
      ErrorMessageHandler(error);
    }
  };
export const editDefaultCertificate = (id, data, lang) => async (dispatch) => {
  try {
    dispatch(setLoading(true));

    const response = await fetchWrapper.patch(`/certificate/template/${id}/`, data);
    if (data.is_default) {
      dispatch(setDefaultCertificate(data));
    }

    dispatch(patchDefaultCertificate(response.data));
    dispatch(
      setUiMessage(
        lang === 'ne'
          ? ' प्रमाणपत्र टेम्प्लेट सफलतापूर्वक अपडेट गरियो'
          : 'Certificate template updated successfully'
      )
    );
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
    ErrorMessageHandler(error);
  }
};

export const deleteDefaultCertificate = (id, lang) => async (dispatch) => {
  try {
    await fetchWrapper.delete(`/certificate/template/${id}/`);
    dispatch(removeDefaultCertificate(id));
    dispatch(
      setUiMessage(
        lang === 'ne'
          ? ' प्रमाणपत्र टेम्प्लेट सफलतापूर्वक हटाईयो'
          : 'Certificate template deleted successfully'
      )
    );
  } catch (error) {
    dispatch(setLoading(false));
    ErrorMessageHandler(error);
  }
};
